import React, { Component } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Skeleton from "react-loading-skeleton";

class PhotoCard extends Component {
  state = {
    0: false,
    1: false
  };
  getPhotos = photos => {
    if (photos && photos.length > 0) {
      return photos.map((photo, index) => {
        if (photo.status === "DONE") {
          return (
            <div
              style={{
                margin: "auto",
                position: "relative",
                minHeight: "210px",
                minWidth: "210px",
                margin: "auto",
                border: "0px solid black",
                padding: "5px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <div
                style={{
                  textAlign: "center"
                }}
              >
                <LazyLoadImage
                  src={
                    "https://storage.googleapis.com/bcsfbtest/images/" +
                    photo.imageName
                  }
                  style={{
                    maxHeight: "200px",
                    maxWidth: "200px",
                    height: this.state[index] ? "200px" : null,
                    width: this.state[index] ? "200px" : null,
                    borderRadius: "10px",
                    border: "0px solid gainsboro",
                    objectFit: "contain",
                    position: "abosolute",
                    top: "0",
                    left: "0",
                    zIndex: "2"
                  }}
                  effect="blur"
                  afterLoad={() => {
                    //console.log("setting to true");
                    this.setState(prevState => {
                      return {
                        ...prevState,
                        [index]: true
                      };
                    });
                  }}
                  visibleByDefault={false}
                />

                {!this.state[index] && (
                  <Skeleton
                    style={{
                      height: "200px",
                      width: "200px",
                      borderRadius: "10px",
                      border: "0px solid gainsboro",
                      objectFill: "cover",
                      position: "absolute",
                      top: "0",
                      left: "0",
                      zIndex: "3"
                    }}
                    duration={1}
                  />
                )}
              </div>
            </div>
          );
        } else {
          return (
            <div
              style={{
                margin: "auto"
              }}
            >
              <Skeleton
                style={{
                  minHeight: "200px",
                  maxHeight: "200px",
                  minWidth: "200px",
                  borderRadius: "10px",
                  border: "0px solid gainsboro",
                  objectFill: "cover",
                  margin: "5px"
                }}
              />
            </div>
          );
        }
      });
    }
  };

  getPhotosFast = photos => {
    if (photos && photos.length > 0) {
      return photos.map((photo, index) => {
        if (photo.status === "DONE") {
          return (
            <div
              style={{
                margin: "auto",
                position: "relative",
                minHeight: "210px",
                minWidth: "210px",
                margin: "auto",
                border: "0px solid black",
                padding: "5px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <div
                style={{
                  textAlign: "center"
                }}
              >
                <img
                  src={
                    "https://storage.googleapis.com/bcsfbtest/images/" +
                    photo.imageName
                  }
                  style={{
                    maxHeight: "200px",
                    maxWidth: "200px",
                    height: "200px",
                    width: "200px",
                    borderRadius: "10px",
                    border: "0px solid gainsboro",
                    objectFit: "contain",
                    position: "abosolute",
                    top: "0",
                    left: "0",
                    zIndex: "2"
                  }}
                />
              </div>
            </div>
          );
        } else {
          return (
            <div
              style={{
                margin: "auto"
              }}
            >
              <Skeleton
                style={{
                  minHeight: "200px",
                  maxHeight: "200px",
                  minWidth: "200px",
                  borderRadius: "10px",
                  border: "0px solid gainsboro",
                  objectFill: "cover",
                  margin: "5px"
                }}
              />
            </div>
          );
        }
      });
    }
  };

  render() {
    return (
      <div
        style={{
          display: "flex",
          overflow: "scroll"
        }}
      >
        {this.getPhotosFast(this.props.photos)}
      </div>
    );
  }
}

export default PhotoCard;



// WEBPACK FOOTER //
// ./src/app/components/Screens/ContentGrid/PhotoCard.jsx